export default "__VITE_ASSET__SA6kb1vE__"